import * as actionTypes from "../actionTypes";
import axios from "../../../services/axios";
import {setMessage} from "../message";

export const setEmployees = (markSheetSubjectEmployees) => {
    return {
        type: actionTypes.SET_EMPLOYEES_LIST,
        employees: markSheetSubjectEmployees
    }
}

export const loadEmployees = () => {
    return {
        type: actionTypes.LOAD_EMPLOYEES
    }
}

export const resetEmployees = () => {
    return {
        type: actionTypes.RESET_EMPLOYEES
    }
}

export const getEmployeesByFio = (fio) => {
    return (dispatch) => {
        dispatch(loadEmployees())
        axios.get( `/api/v1/employees/fio/requests?employee-fio=` + fio )
            .then( response => {
                dispatch( setEmployees(response.data))
            } )
            .catch( error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

////////////////////////////////////////////////////////////////

export const setMarkSheetSubjectEmployees = (markSheetSubjectEmployees) => {
    return {
        type: actionTypes.SET_MARK_SHEET_SUBJECT_EMPLOYEES,
        markSheetSubjectEmployees: markSheetSubjectEmployees
    }
}

export const loadMarkSheetSubjectSubjectEmployees = () => {
    return {
        type: actionTypes.LOAD_MARK_SHEET_SUBJECT_EMPLOYEES
    }
}

export const resetMarkSheetSubjectSubjectEmployees = () => {
    return {
        type: actionTypes.RESET_MARK_SHEET_SUBJECT_EMPLOYEES
    }
}

export const getMarkSheetSubjectEmployeesByThId = (thId) => {
    return (dispatch) => {
        dispatch(loadMarkSheetSubjectSubjectEmployees())
        axios.get( `/api/v1/employees/mark-sheet?thId=` + thId)
            .then( response => {
                dispatch( setMarkSheetSubjectEmployees(response.data))
            } )
            .catch( error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось найти преподавателя."}))
            } );
    }
}

export const getMarkSheetSubjectEmployeesByFocsId = (focsId) => {
    return (dispatch) => {
        dispatch(loadMarkSheetSubjectSubjectEmployees())
        axios.get( `/api/v1/employees/mark-sheet?focsId=` + focsId)
            .then( response => {
                dispatch( setMarkSheetSubjectEmployees(response.data))
            } )
            .catch( error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось найти преподавателя."}))
            } );
    }
}